module.exports = __webpack_public_path__ + "img/10-small.2b24b197.png";